import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Database } from '../../../models/database';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-edit-database-details-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './edit-database-details-modal.component.html',
  styleUrl: './edit-database-details-modal.component.scss'
})
export class EditDatabaseDetailsModalComponent implements OnInit {

  @Input() database!: Database;
  editForm!: FormGroup;

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.editForm = this.fb.group({
      host: [this.database.connection_details.host, Validators.required],
      username: [this.database.connection_details.username, Validators.required],
      password: ['', Validators.required], // Password is always required
      role: [this.database.connection_details.role || 'ACCOUNTADMIN'],
      warehouse: [this.database.connection_details.warehouse],
      port: [this.database.connection_details.port || this.getDefaultPort()],
      database: [this.database.connection_details.database || ''],
    });

    // Disable fields based on platform type
    if (this.database.platform_type === 'snowflake') {
      this.editForm.get('host')?.disable();
      // this.editForm.get('warehouse')?.disable();
    } else if (
      this.database.platform_type === 'mysql' ||
      this.database.platform_type === 'postgres'
    ) {
      this.editForm.get('host')?.disable();
      // this.editForm.get('database')?.disable();
    }
  }

  getDefaultPort(): string {
    if (this.database.platform_type === 'mysql') {
      return '3306';
    } else if (this.database.platform_type === 'postgres') {
      return '5432';
    }
    return '';
  }

  save(): void {
    if (this.editForm.valid) {
      const updatedData = this.editForm.getRawValue(); // Include disabled fields
      const payload: Database ={
        platform_name: this.database.platform_name,
        platform_type: this.database.platform_type,
        connection_details: {
          host: updatedData.host,
          username: updatedData.username,
          password: updatedData.password,
        },
        last_tested: new Date().toISOString(),
        is_connected: this.database.is_connected,
        status: this.database.status
      }

      switch(this.database.platform_type){
        case 'snowflake':
          payload.connection_details.role = updatedData.role;
          payload.connection_details.warehouse = updatedData.warehouse;
          break;
        case 'mysql':
        case 'postgres':
          payload.connection_details.port = updatedData.port;
          payload.connection_details.database = updatedData.database;
          break
      }

      // console.log("Paylaod_Data_Updated :", payload)
      this.activeModal.close(payload);
    }
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }
}
